<script>
import baseMixin from '@/mixins/baseMixin'
import { CreateBookingSteps } from '@/shared/constants/booking/BookingSelectEducators'
import { mapGetters } from 'vuex'

export default {
  name: 'BookingCreateStepperV2',
  mixins: [baseMixin],
  props: {
    value: {
      type: Number,
      default: CreateBookingSteps.DetailsStep,
      validator: (step) =>
        step >= CreateBookingSteps.DetailsStep &&
        step <= CreateBookingSteps.SelectEducatorsStep,
    },
  },
  computed: {
    ...mapGetters({
      isSendToANZUK: 'bookings/isSendToANZUK',
    }),
    currentStep() {
      return this.value
    },
    stepperValue() {
      return Math.min(this.currentStep, this.steps.length)
    },
    steps() {
      return [
        {
          step: CreateBookingSteps.DetailsStep,
          label: this.$t('bookingCreateV2.stepper.details'),
        },
        {
          step: CreateBookingSteps.SelectEducatorsStep,
          label: this.$t('bookingCreateV2.selectEducators'),
          disabled: this.isSendToANZUK,
        },
      ]
    },
  },
}
</script>

<template>
  <nav
    data-testid="booking-create-stepper-v2"
    class="w-100"
    aria-label="Booking creation progress"
  >
    <v-stepper :value="stepperValue" class="transparent" flat>
      <v-stepper-header
        class="d-flex align-center justify-start py-2 px-3 elevation-0"
      >
        <div
          v-for="{ step, label, disabled = false } in steps"
          :key="step"
          class="d-flex align-center"
        >
          <v-stepper-step
            :step="step"
            :complete="currentStep > step"
            complete-icon="mdi-check"
            class="pa-0"
            :class="[
              { 'current-step': currentStep === step },
              { 'opacity-50': disabled },
            ]"
          >
            <span class="display-xs">{{ label }}</span>
          </v-stepper-step>

          <span
            v-if="step < steps.length"
            class="grey lighten-1 rounded-lg flex-shrink-0 mx-2 d-inline-block"
            style="width: 40px; height: 2px"
            aria-hidden="true"
          />
        </div>
      </v-stepper-header>
    </v-stepper>
  </nav>
</template>

<style lang="scss" scoped>
@import '@/styles/_vue-transitions.scss';
@import '@/styles/_r2b-colours.scss';

.current-step {
  ::v-deep .v-stepper__step__step {
    color: $brand-blue-400 !important;
    background: $neutrals-black-and-white-white !important;
    border: 1px solid $brand-blue-400;
  }
}
</style>
